import merge from 'lodash/merge';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box, TextField, CardProps } from '@mui/material';
// components
import { BaseOptionChart } from '../../../../../components/chart';

// ----------------------------------------------------------------------

export interface ChartBarProps extends CardProps {
  title?: string;
  subheader?: string;
  chartLabels: string[];
  chartData: {
    label: string;
    value: string | number;
    data: {
      name: string;
      data: number[];
    }[];
  }[];
  onSeriesChange: (value: string | number) => void;
  selectedSeries: string | number;
}

export default function ChartBar({
  title,
  subheader,
  chartLabels,
  chartData,
  onSeriesChange,
  selectedSeries,
  ...other
}: ChartBarProps) {
  const handleChangeSeriesData = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSeriesChange(event.target.value);
  };

  const chartOptions = merge(BaseOptionChart(), {
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: chartLabels,
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val}`,
      },
    },
  });

  return (
    <Card {...other}>
      <CardHeader
        title={title}
        subheader={subheader}
        action={
          <TextField
            select
            fullWidth
            value={selectedSeries}
            SelectProps={{ native: true }}
            onChange={handleChangeSeriesData}
            sx={{
              '& fieldset': { border: '0 !important' },
              '& select': { pl: 1, py: 0.5, pr: '24px !important', typography: 'subtitle2' },
              '& .MuiOutlinedInput-root': { borderRadius: 0.75, bgcolor: 'background.neutral' },
              '& .MuiNativeSelect-icon': { top: 4, right: 0, width: 20, height: 20 },
            }}
          >
            {chartData.map((option) => (
              <option key={`${option.value}-${option.label}`} value={option.value}>
                {option.label}
              </option>
            ))}
          </TextField>
        }
      />

      {chartData.map((item) => (
        <Box key={item.value} sx={{ mt: 3, mx: 3 }} dir="ltr">
          {item.value === selectedSeries && (
            <ReactApexChart type="bar" series={item.data} options={chartOptions} height={364} />
          )}
        </Box>
      ))}
    </Card>
  );
}
